// marginx keyboard hint bar (inline-styled): rendered INSIDE the Footer (center
// section) so it shares the single bottom bar. Idle it shows the curated
// HINT_ITEMS; while a chord is pending it shows the pressed prefix and defers to
// the <ChordOverlay> popup for the full list of next keys.
import { HINT_ITEMS, formatToken } from "keyboard/shortcuts";
import { useKeyboardBuffer, useKeyboardContext } from "keyboard/useKeyboard";
import type { CSSProperties } from "react";
import {
  BORDER_COLORS,
  COLORS,
  FIELD_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";

export function HintBar() {
  const { manager } = useKeyboardContext();
  const buffer = useKeyboardBuffer(); // re-renders on chord / scope changes

  const pending = buffer.length ? buffer.map(formatToken).join(" ") : null;
  const items = HINT_ITEMS.filter((i) => manager.isScopeActive(i.scope));

  return (
    <div
      role="status"
      aria-label="Keyboard shortcut hints"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 16,
        minWidth: 0,
        overflow: "hidden",
        fontSize: 11,
        color: TEXT_COLORS.two,
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: pending ? COLORS.highlight.one : TEXT_COLORS.three, display: "inline-block" }} />
        <span style={{ color: TEXT_COLORS.three }}>Keyboard</span>
      </span>

      {pending ? (
        <span style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
          <kbd style={{ ...hintKbd, color: COLORS.highlight.one }}>{pending}</kbd>
          <span style={{ color: TEXT_COLORS.three }}>then… (see options above)</span>
        </span>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 16, overflow: "hidden" }}>
          {items.map((i) => (
            <span key={`${i.scope}:${i.label}`} style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
              <kbd style={hintKbd}>{i.keys}</kbd>
              <span>{i.label}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

const hintKbd: CSSProperties = {
  border: `1px solid ${BORDER_COLORS.three}`,
  background: FIELD_COLORS.one,
  borderRadius: 3,
  padding: "0 4px",
  fontFamily: "monospace",
  color: TEXT_COLORS.two,
  flexShrink: 0,
};
